<template>
    <v-row class="mb-1 py-1" no-gutters align="center">
        <v-col cols="12" sm="7" md="7" lg="7" class="d-flex justify-start align-center px-3 flex-wrap">
            <v-icon left>mdi-account</v-icon>
            <b>{{ client.first_name }} {{ client.last_name }}</b>
            <div class="ma-2 c-label" label v-if="client.isPrincipal">
                <v-icon left class="white-color"> mdi-label </v-icon>
                {{ $t('calendar.modal.principal') }}
            </div>
        </v-col>
        <v-col cols="2" sm="1" md="1" lg="1" class="d-flex justify-center">
            <v-btn
                class="mx-2"
                fab
                dark
                color="indigo"
                @click="disintermentCount"
                :disabled="count < 1 || (client.isPrincipal && shouldTakeAll)"
            >
                <v-icon dark>mdi-minus</v-icon>
            </v-btn>
        </v-col>
        <v-col cols="3" sm="1" md="1" lg="1">
            <v-chip class="ma-2 d-flex justify-center align-center">
                {{ !shouldTakeAll || !client.isPrincipal ? count : nbPlaces }}
            </v-chip>
        </v-col>
        <v-col cols="2" sm="1" md="1" lg="1" class="d-flex justify-center">
            <v-btn
                class="mx-2"
                fab
                dark
                color="indigo"
                @click="incrementCount"
                :disabled="nbPlaces <= 0 || (shouldTakeAll && client.isPrincipal)"
            >
                <v-icon dark>mdi-plus</v-icon>
            </v-btn>
        </v-col>
        <v-col cols="5" sm="2" md="2" lg="2" class="d-flex justify-center">
            <div v-if="loading">{{ $t('calendar.modal.calculating') }}</div>
            <div v-else>{{ total.toFixed(2) }} {{ $symbolCurrency }}</div>
        </v-col>
    </v-row>
</template>
<script>
export default {
    props: ['prestation', 'client', 'shouldTakeAll', 'loading', 'setToZero'],
    data: () => {
        return {
            count: 0,
            total: 0,
            totalPrice: 0,
            nbPlaces: 0,
            debug: false,
        }
    },
    methods: {
        incrementCount() {
            if (this.nbPlaces > 0) {
                this.count++
                this.nbPlaces--
            }
        },
        disintermentCount() {
            if (this.count > 0) {
                this.count--
                this.nbPlaces++
            }
        },
        refreshData() {
            this.nbPlaces = this.prestation.nbFreePlaces
            this.refreshTotalPrice()
        },
        refreshTotalPrice() {
            //  if (this.debug) console.log('refreshTotalPrice')
            this.total = this.prestation?.priceDetails?.byTicket
                ? this.prestation.priceDetails.byTicket.price * this.client.count
                : 0
        },
        initData() {
            this.nbPlaces = this.prestation.nbFreePlaces
            if (this.prestation.subcategory.slug.toLowerCase() == 'events') {
                this.count = 0
                //  if (this.debug) console.log('initData nbAvailablePlaces ', this.prestation.nbFreePlaces, this.shouldTakeAll)
            } else {
                if (this.client.isPrincipal && this.shouldTakeAll) {
                    this.count = this.prestation.nbFreePlaces
                } else {
                    this.count = 0
                }
            }
        },
    },
    watch: {
        count() {
            if (this.debug) console.log('Watcher triggered: count')
            this.$emit('count-changed', this.client, this.count, this.prestation)
        },

        // prestation: {
        //     deep: true,
        //     handler(val, old) {
        //         if (this.debug) console.log('Watcher triggered: prestation', val, old)
        //         if (this.debug) console.log('change prestation ARP', this.prestation.nbFreePlaces)
        //         // this.refreshData();
        //     },
        // },

        'prestation.selectedSpace'(val, old) {
            if (this.debug) console.log('Watcher triggered: prestation.selectedSpace', val, old)
            this.count = 0
            this.initData()
            this.refreshData()
        },

        'prestation.nbFreePlaces'(val, old) {
            if (val != old) {
                if (this.debug) console.log('Watcher triggered: prestation.nbFreePlaces', val, old)
                // this.count = 0
                // this.initData()
                this.refreshData()
            }
        },

        'prestation.selectedClients'(val, old) {
            if (this.debug) console.log('Watcher triggered: prestation.selectedClients', val, old)
            if (val.length !== old.length) {
                this.initData()
            }
        },
        loading: {
            immediate: true, // Run this immediately when the component is created
            handler(newVal) {
                if (this.debug) console.log('Watcher triggered: loading ARP', newVal)
                this.refreshData()
            },
        },

        setToZero() {
            if (this.debug) console.log('Watcher triggered: setToZero')
            this.initData()
        },

        client: {
            deep: true,
            handler(newValue, oldValue) {
                if (this.debug) console.log('Watcher triggered: client', newValue, oldValue)
                // Handle the changes here
            },
        },
    },

    mounted() {
        this.initData()
        this.refreshData()
        // this.debug = process.env.NODE_ENV === 'development' // Enable logging only in development mode
        // this.client.count = 0
    },
}
</script>
<style scoped>
.c-label {
    color: beige !important;
    background-color: #1a7b00 !important;
    padding: 3px 9px !important;
    font-weight: bold;
    border-radius: 3px;
    border-radius: 3px;
    display: flex;
    justify-content: center;
}
.white-color {
    color: #fff !important;
}
</style>
